import { render, staticRenderFns } from "./Watch.vue?vue&type=template&id=98c80a86&"
import script from "./Watch.vue?vue&type=script&lang=js&"
export * from "./Watch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports